var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 293.33 100.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#a73724;}.cls-3{isolation:isolate;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#7b2310;}.cls-6{fill:#7e2412;}.cls-7{fill:#812513;}.cls-8{fill:#79210f;}.cls-9{fill:#76200d;}.cls-10{fill:#731f0c;}.cls-11{fill:#711d0a;}.cls-12{fill:#6e1c08;}.cls-13{fill:#0a0909;}.cls-14{fill:#6d1b08;}.cls-15{fill:#862816;}.cls-16{clip-path:url(#clip-path-2);}.cls-17{clip-path:url(#clip-path-3);}.cls-18{clip-path:url(#clip-path-4);}.cls-19{clip-path:url(#clip-path-5);}.cls-20{clip-path:url(#clip-path-6);}.cls-21{clip-path:url(#clip-path-7);}.cls-22{clip-path:url(#clip-path-8);}.cls-23{fill:#9a311f;}.cls-24{clip-path:url(#clip-path-9);}.cls-25{clip-path:url(#clip-path-10);}.cls-26{clip-path:url(#clip-path-11);}.cls-27{clip-path:url(#clip-path-12);}.cls-28{clip-path:url(#clip-path-13);}.cls-29{clip-path:url(#clip-path-14);}.cls-30{clip-path:url(#clip-path-15);}.cls-31{clip-path:url(#clip-path-16);}.cls-32{clip-path:url(#clip-path-17);}.cls-33{clip-path:url(#clip-path-18);}.cls-34{clip-path:url(#clip-path-19);}.cls-35{fill:#7c2310;}.cls-36{fill:#741f0c;}.cls-37{clip-path:url(#clip-path-20);}.cls-38{clip-path:url(#clip-path-21);}.cls-39{clip-path:url(#clip-path-22);}.cls-40{fill:#872816;}.cls-41{fill:#6c1a07;}.cls-42{clip-path:url(#clip-path-23);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.16,61.92c3.06-.43,6.45-5.62,6.46-11.45L237.18,53c0,5.83-3.4,11-6.46,11.45l-1.1-.59-1.78-1-1.68-.92,4.56,2.48a2.53,2.53,0,0,1-1.62-.28l-4.56-2.48A2.54,2.54,0,0,0,226.16,61.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232,47.88a15.34,15.34,0,0,0-.11-1.82l4.56,2.48a13.51,13.51,0,0,1,.1,1.82Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.44,73.36l-4.56-2.48A4.28,4.28,0,0,1,219.76,67l4.56,2.48A4.24,4.24,0,0,0,226.44,73.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.87,46.06a12.82,12.82,0,0,0-.86-3.32l4.56,2.48a12.82,12.82,0,0,1,.86,3.32C235.06,47.8,233.23,46.81,231.87,46.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.1,64.12l-4.56-2.48c-1.75-1-2.75-4-3-7.9l4.56,2.48C226.35,60.12,227.35,63.17,229.1,64.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231,42.74a7.91,7.91,0,0,0-3.25-4l4.56,2.48a7.91,7.91,0,0,1,3.25,4l-.53-.29-.57-.31-.58-.32-.3-.16-1.48-.81-.56-.3A2.32,2.32,0,0,1,231,42.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.76,38.7l4.56,2.48a3.52,3.52,0,0,0-2.21-.45l-4.56-2.48A3.52,3.52,0,0,1,227.76,38.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.44,51.92l-4.56-2.48c0-5.82,1.61-10.76,4.67-11.19l4.56,2.48C227.05,41.16,225.45,46.1,225.44,51.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.19,27.86l4.56,2.48a3.89,3.89,0,0,0-2.43-.42l-4.56-2.48A3.89,3.89,0,0,1,231.19,27.86Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.38,36.09l-4.56-2.48a5.69,5.69,0,0,1,4.57-5.56L229,30.53A5.69,5.69,0,0,0,224.38,36.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.57,61.17c3.07-.43,6.45-5.63,6.46-11.45l4.56,2.47c0,5.83-3.39,11-6.46,11.46a2.62,2.62,0,0,1-1.62-.28L281,60.89A2.58,2.58,0,0,0,282.57,61.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.39,47.13a15.21,15.21,0,0,0-.11-1.82l4.56,2.48a15.21,15.21,0,0,1,.11,1.82Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.85,72.61l-4.55-2.48a4.29,4.29,0,0,1-2.13-3.86l4.56,2.48A4.3,4.3,0,0,0,282.85,72.61Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.51,63.37,281,60.89c-1.75-1-2.76-4-3-7.9l4.56,2.48C282.76,59.36,283.76,62.41,285.51,63.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.28,45.31c-.44-3.56-2.15-6.3-4.11-7.37l4.56,2.48c2,1.07,3.67,3.81,4.11,7.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.17,37.94l4.56,2.48a3.57,3.57,0,0,0-2.2-.45L282,37.49A3.57,3.57,0,0,1,284.17,37.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.6,27.11l4.56,2.48a3.82,3.82,0,0,0-2.43-.42l-4.55-2.48A3.79,3.79,0,0,1,287.6,27.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.85,51.17l-4.56-2.48c0-5.82,1.62-10.77,4.68-11.2L286.53,40C283.47,40.4,281.86,45.35,281.85,51.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.79,35.34l-4.56-2.48a5.67,5.67,0,0,1,4.57-5.56l4.56,2.48A5.67,5.67,0,0,0,280.79,35.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82,1l4.56,2.48A4.09,4.09,0,0,0,84,3L79.4.51A4.08,4.08,0,0,1,82,1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.51,3.08,79,.6A3.58,3.58,0,0,1,79.4.51L84,3A3.58,3.58,0,0,0,83.51,3.08Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.14,35.39,3.58,32.91a4.42,4.42,0,0,1-2.21-3.57l4.56,2.48A4.42,4.42,0,0,0,8.14,35.39Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(-0.96 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.54,27.29,1,24.81A6,6,0,0,1,5.3,18.56L9.86,21A6,6,0,0,0,5.54,27.29Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("text", {
    x: -0.96,
    y: -0.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.62,52.22l13,.4q-1.38,10.79-7.08,16.51t-14.8,5.73A20.87,20.87,0,0,1,77,68.37a22.54,22.54,0,0,1-6.24-16.28,22.89,22.89,0,0,1,6.4-16.52A21.12,21.12,0,0,1,93,28.92a20.47,20.47,0,0,1,13.8,5q5.76,5,7.65,14.29l-13.3,1Q99,41.89,92.72,41.89a8.47,8.47,0,0,0-6.55,2.85,10.46,10.46,0,0,0-2.61,7.35,10,10,0,0,0,2.54,7,8.4,8.4,0,0,0,6.43,2.75Q100.62,61.89,101.62,52.22Z",
    transform: "translate(-0.96 -0.47)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u773C\\u775B\\u9EC4\\u8272"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.1,64.12l-4.56-2.48.1,0,4.56,2.48-.1,0",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.2,64.17l-4.56-2.48a2.22,2.22,0,0,0,.49.18l4.56,2.48a2.22,2.22,0,0,1-.49-.18",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M229.69,64.35l-4.56-2.48a2.72,2.72,0,0,0,1,.05,3.55,3.55,0,0,0,1-.32l4.56,2.48a3.55,3.55,0,0,1-1,.32,2.71,2.71,0,0,1-1-.05",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.76,64.08,227.2,61.6a5.46,5.46,0,0,0,.73-.42l4.56,2.48a5.46,5.46,0,0,1-.73.42",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.49,63.66l-4.56-2.48a6.7,6.7,0,0,0,.68-.54l4.56,2.48a8,8,0,0,1-.68.54",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M233.17,63.12l-4.56-2.48a8.89,8.89,0,0,0,.68-.69l4.56,2.48a8.89,8.89,0,0,1-.68.69",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M233.85,62.43,229.29,60c.25-.29.49-.6.73-.93l4.56,2.48c-.24.33-.48.64-.73.93",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M234.58,61.5,230,59a11.46,11.46,0,0,0,.78-1.28l4.56,2.48a14.51,14.51,0,0,1-.78,1.28",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.36,60.22l-4.56-2.48a15,15,0,0,0,.86-1.9l4.55,2.48a13.68,13.68,0,0,1-.85,1.9",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.21,58.32l-4.55-2.48a15.9,15.9,0,0,0,1-5.37L237.18,53a15.9,15.9,0,0,1-1,5.37",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "235.16 52.63 230.6 50.15 231.66 50 236.22 52.48 235.16 52.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "235.15 54.35 230.59 51.87 230.6 50.15 235.16 52.63 235.15 54.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "236.8 49.72 232.25 47.24 232.25 45.41 236.81 47.89 236.8 49.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "235.47 48.08 230.91 45.59 232.25 45.41 236.81 47.89 235.47 48.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "225.17 55.75 220.61 53.27 230.59 51.87 235.15 54.35 225.17 55.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "223.39 54.28 218.83 51.8 230.6 50.15 235.16 52.63 223.39 54.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "225.04 51.37 220.49 48.89 231.02 47.41 235.58 49.89 225.04 51.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "225.04 51.37 220.49 48.89 232.25 47.24 236.8 49.72 225.04 51.37"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M236.53,50.36,232,47.88a15.34,15.34,0,0,0-.11-1.82l4.56,2.48a13.51,13.51,0,0,1,.1,1.82",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M226.44,73.36l-4.56-2.48A4.28,4.28,0,0,1,219.76,67l4.56,2.48a4.24,4.24,0,0,0,2.12,3.86",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.43,48.54l-4.56-2.48c-.44-3.55-2.15-6.3-4.11-7.36l4.56,2.48c2,1.06,3.67,3.81,4.11,7.36",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M229.1,64.12l-4.56-2.48c-1.75-1-2.75-4-3-7.9l4.56,2.48c.22,3.9,1.22,7,3,7.9",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.43,48.54l-4.56-2.48c-.44-3.55-2.15-6.3-4.11-7.36l4.56,2.48c2,1.06,3.67,3.81,4.11,7.36",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.76,48.35v1.84L226,51.84l10.53-1.48a13.51,13.51,0,0,0-.1-1.82Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "223.39 56.01 218.83 53.52 220.61 53.27 225.17 55.75 223.39 56.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "223.39 56.01 218.83 53.52 218.83 51.8 223.39 54.28 223.39 56.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "224.48 51.45 219.93 48.97 220.49 48.89 225.04 51.37 224.48 51.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M230.11,40.73l-4.56-2.48a3.26,3.26,0,0,1,1.28.08l4.56,2.48a3.26,3.26,0,0,0-1.28-.08",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M231.39,40.81l-4.56-2.48a3.67,3.67,0,0,1,.76.28l4.56,2.48a3.89,3.89,0,0,0-.76-.28",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M232.15,41.09l-4.56-2.48.17.09,4.56,2.48-.17-.09",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M225.44,51.92l-4.56-2.48A22.41,22.41,0,0,1,222,42.05l4.56,2.48a22.41,22.41,0,0,0-1.11,7.39",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M226.55,44.53,222,42.05a10.23,10.23,0,0,1,.59-1.33l4.56,2.48a9,9,0,0,0-.59,1.33",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M227.14,43.2l-4.56-2.48A8.29,8.29,0,0,1,223,40l4.56,2.48a8.29,8.29,0,0,0-.44.73",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M227.58,42.47,223,40a5.15,5.15,0,0,1,.4-.5L228,42a5.15,5.15,0,0,0-.4.5",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228,42l-4.56-2.48a4.68,4.68,0,0,1,.38-.39l4.56,2.48A4.68,4.68,0,0,0,228,42",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.36,41.58,223.8,39.1a3.79,3.79,0,0,1,.39-.31l4.56,2.48a3.79,3.79,0,0,0-.39.31",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.75,41.27l-4.56-2.48a4,4,0,0,1,.48-.28L229.23,41a4,4,0,0,0-.48.28",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M229.23,41l-4.56-2.48a3.07,3.07,0,0,1,.88-.26l4.56,2.48a3.07,3.07,0,0,0-.88.26",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M230.11,40.73c2.74-.39,5.72,3,6.32,7.81a13.51,13.51,0,0,1,.1,1.82L226,51.84l-.56.08C225.45,46.1,227.05,41.16,230.11,40.73Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M233.32,29.92a4,4,0,0,1,4.55,4.27l-.06,33.42a5.69,5.69,0,0,1-4.57,5.56l-4.37.61a4,4,0,0,1-4.55-4.28l0-13,1.79-.25c.28,5,1.84,8.57,4.59,8.18,3.06-.43,6.45-5.62,6.46-11.45l-1.07.15-11.76,1.65,0-18.66A5.69,5.69,0,0,1,229,30.53Zm4.44,20.27V48.35l-1.33.19c-.6-4.86-3.58-8.2-6.32-7.81-3.06.43-4.66,5.37-4.67,11.19l.56-.08,11.76-1.65",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.18,53c0,5.83-3.4,11-6.46,11.45-2.75.39-4.31-3.21-4.59-8.18l10-1.4V53.1Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "223.36 69.03 218.8 66.56 218.83 53.52 223.39 56.01 223.36 69.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "235.16 52.63 235.15 54.35 225.17 55.75 223.39 56.01 223.39 54.28 235.16 52.63"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.32,29.92l-4.56-2.48a3.91,3.91,0,0,1,1.57.08L234.89,30a3.91,3.91,0,0,0-1.57-.08",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.89,30l-4.56-2.48a4.44,4.44,0,0,1,.72.27l4.56,2.48a4.44,4.44,0,0,0-.72-.27",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M235.61,30.27l-4.56-2.48.14.07,4.56,2.48-.14-.07",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "227.99 30.07 223.43 27.59 227.81 26.97 232.36 29.45 227.99 30.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "223.39 54.28 218.83 51.8 218.87 33.14 223.42 35.62 223.39 54.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M224.38,36.09l-4.56-2.48a5.67,5.67,0,0,1,.35-1.92l4.56,2.48a5.67,5.67,0,0,0-.35,1.92",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M224.73,34.17l-4.56-2.48a5.89,5.89,0,0,1,.35-.77l4.55,2.48a7.51,7.51,0,0,0-.34.77",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M225.07,33.4l-4.55-2.48a4.6,4.6,0,0,1,.37-.6l4.56,2.48a6.1,6.1,0,0,0-.38.6",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M225.45,32.8l-4.56-2.48c.13-.19.27-.36.41-.53l4.56,2.48a5.34,5.34,0,0,0-.41.53",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.86,32.27l-4.56-2.48c.15-.17.31-.32.47-.47l4.56,2.48c-.16.15-.32.3-.47.47",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226.33,31.8l-4.56-2.48a5.58,5.58,0,0,1,.55-.44l4.56,2.48a5.58,5.58,0,0,0-.55.44",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.88,31.36l-4.56-2.48a5.59,5.59,0,0,1,.75-.43l4.55,2.48a6.17,6.17,0,0,0-.74.43",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M227.62,30.93l-4.55-2.48a5,5,0,0,1,1.32-.4L229,30.53a5.11,5.11,0,0,0-1.33.4",
    transform: "translate(-0.96 -0.47)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.51,63.37,281,60.89l.09,0,4.56,2.48a.31.31,0,0,0-.1-.05",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.61,63.42l-4.56-2.48a2.3,2.3,0,0,0,.5.18l4.56,2.48a3,3,0,0,1-.5-.18",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.11,63.6l-4.56-2.48a2.66,2.66,0,0,0,1,.05,3.67,3.67,0,0,0,1-.32l4.56,2.48a3.77,3.77,0,0,1-1,.32,2.66,2.66,0,0,1-1,0",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.17,63.33l-4.56-2.48a5.07,5.07,0,0,0,.74-.43l4.56,2.48a5.07,5.07,0,0,1-.74.43",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.91,62.9l-4.56-2.48a6.6,6.6,0,0,0,.67-.54l4.56,2.48a6.6,6.6,0,0,1-.67.54",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M289.58,62.36,285,59.88a7.49,7.49,0,0,0,.69-.69l4.55,2.48a7.41,7.41,0,0,1-.68.69",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.26,61.67l-4.55-2.48a9.78,9.78,0,0,0,.72-.92L291,60.75a8.43,8.43,0,0,1-.73.92",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M291,60.75l-4.56-2.48a14.57,14.57,0,0,0,.79-1.28l4.56,2.48a14.57,14.57,0,0,1-.79,1.28",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M291.78,59.47,287.22,57a16.53,16.53,0,0,0,.85-1.9l4.56,2.48a16.53,16.53,0,0,1-.85,1.9",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M292.63,57.57l-4.56-2.48a15.9,15.9,0,0,0,1-5.37l4.56,2.47a15.91,15.91,0,0,1-1,5.38",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "291.57 51.88 287.01 49.4 288.08 49.25 292.63 51.73 291.57 51.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "291.57 53.6 287.01 51.12 287.01 49.4 291.57 51.88 291.57 53.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "293.22 48.97 288.67 46.48 288.67 44.65 293.23 47.13 293.22 48.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M293,49.61l-4.56-2.48a15.21,15.21,0,0,0-.11-1.82l4.56,2.48a15.21,15.21,0,0,1,.11,1.82",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M282.85,72.61l-4.55-2.48a4.29,4.29,0,0,1-2.13-3.86l4.56,2.48a4.3,4.3,0,0,0,2.12,3.86",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285.51,63.37,281,60.89c-1.75-1-2.76-4-3-7.9l4.56,2.48c.22,3.89,1.22,6.94,3,7.9",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M293.59,52.19c0,5.83-3.39,11-6.46,11.46-2.75.38-4.31-3.21-4.59-8.18l10-1.4V52.34Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "281.58 55 277.03 52.52 287.01 51.12 291.57 53.6 281.58 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "279.8 55.25 275.24 52.77 277.03 52.52 281.58 55 279.8 55.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "279.77 68.28 275.22 65.8 275.24 52.77 279.8 55.25 279.77 68.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M292.84,47.79l-4.56-2.48c-.44-3.56-2.15-6.3-4.11-7.37l4.56,2.48c2,1.07,3.67,3.81,4.11,7.37",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "279.8 53.53 275.24 51.05 287.01 49.4 291.57 51.88 279.8 53.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "281.46 50.62 276.9 48.14 287.43 46.66 291.99 49.14 281.46 50.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "281.46 50.62 276.9 48.14 288.67 46.48 293.22 48.97 281.46 50.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M294.18,47.6v1.83l-11.77,1.66L293,49.61a15.21,15.21,0,0,0-.11-1.82Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "291.57 51.88 291.57 53.6 281.58 55 279.8 55.25 279.8 53.53 291.57 51.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "279.8 55.25 275.24 52.77 275.24 51.05 279.8 53.53 279.8 55.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "280.9 50.7 276.34 48.22 276.9 48.14 281.46 50.62 280.9 50.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M286.53,40,282,37.49a3.21,3.21,0,0,1,1.27.08l4.56,2.48a3.21,3.21,0,0,0-1.27-.08",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M287.8,40.05l-4.56-2.48a4,4,0,0,1,.77.29l4.56,2.48a4,4,0,0,0-.77-.29",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M288.57,40.34,284,37.86l.16.08,4.56,2.48-.16-.08",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.73,29.17l-4.55-2.48a3.87,3.87,0,0,1,1.56.08l4.56,2.48a3.91,3.91,0,0,0-1.57-.08",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.3,29.25l-4.56-2.48a3.64,3.64,0,0,1,.72.26L292,29.51a3.64,3.64,0,0,0-.72-.26",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292,29.51,287.46,27l.14.08,4.56,2.48-.14-.08",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M281.85,51.17l-4.56-2.48a22.43,22.43,0,0,1,1.11-7.4L283,43.77a22.43,22.43,0,0,0-1.11,7.4",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283,43.77l-4.56-2.48A12.65,12.65,0,0,1,279,40l4.56,2.48a10.87,10.87,0,0,0-.59,1.33",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283.55,42.44,279,40a6.3,6.3,0,0,1,.45-.72L284,41.72a6.3,6.3,0,0,0-.45.72",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M284,41.72l-4.56-2.48a4.91,4.91,0,0,1,.39-.51l4.56,2.48a4.91,4.91,0,0,0-.39.51",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M284.39,41.21l-4.56-2.48a4.54,4.54,0,0,1,.38-.38l4.56,2.48a4.54,4.54,0,0,0-.38.38",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M284.77,40.83l-4.56-2.48a4,4,0,0,1,.4-.32l4.55,2.48c-.13.1-.26.2-.39.32",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285.16,40.51,280.61,38a2.82,2.82,0,0,1,.48-.27l4.56,2.48a3.36,3.36,0,0,0-.49.27",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285.65,40.24l-4.56-2.48a3,3,0,0,1,.88-.27L286.53,40a2.91,2.91,0,0,0-.88.27",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M286.53,40c2.73-.38,5.71,3,6.31,7.82a15.21,15.21,0,0,1,.11,1.82l-10.54,1.48-.56.08C281.86,45.35,283.47,40.4,286.53,40Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "284.4 29.31 279.85 26.83 284.22 26.22 288.78 28.7 284.4 29.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "279.8 53.53 275.24 51.05 275.28 32.39 279.84 34.87 279.8 53.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M280.79,35.34l-4.56-2.48a5.93,5.93,0,0,1,.35-1.92l4.56,2.48a5.67,5.67,0,0,0-.35,1.92",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M281.14,33.42l-4.56-2.48a6,6,0,0,1,.35-.77l4.56,2.48a6,6,0,0,0-.35.77",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M281.49,32.65l-4.56-2.48a6.18,6.18,0,0,1,.37-.61L281.86,32a6.18,6.18,0,0,0-.37.61",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M281.86,32l-4.56-2.48a5.3,5.3,0,0,1,.42-.52l4.56,2.48a5.3,5.3,0,0,0-.42.52",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M282.28,31.52,277.72,29a4.25,4.25,0,0,1,.47-.48L282.74,31a5.22,5.22,0,0,0-.46.48",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.74,31l-4.55-2.48a5.79,5.79,0,0,1,.55-.43l4.56,2.48a5.93,5.93,0,0,0-.56.43",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.3,30.61l-4.56-2.48a4.2,4.2,0,0,1,.74-.43L284,30.18a4.2,4.2,0,0,0-.74.43",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M284,30.18l-4.56-2.48a4.69,4.69,0,0,1,1.32-.4l4.56,2.48a4.69,4.69,0,0,0-1.32.4",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M289.73,29.17a4,4,0,0,1,4.55,4.27l-.06,33.41a5.67,5.67,0,0,1-4.57,5.56l-4.37.62a4,4,0,0,1-4.55-4.28l0-13,1.78-.25c.28,5,1.84,8.56,4.59,8.18,3.07-.43,6.45-5.63,6.46-11.46l-1.06.15L280.76,54l0-18.66a5.67,5.67,0,0,1,4.57-5.56Zm4.45,20.26V47.6l-1.34.19c-.6-4.86-3.58-8.2-6.31-7.82-3.06.43-4.67,5.38-4.68,11.2l.56-.08,11.77-1.66",
    transform: "translate(-0.96 -0.47)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.06,47.47v9.77h-10a5.75,5.75,0,0,0-2.87.53,1.88,1.88,0,0,0-.85,1.72,2,2,0,0,0,.81,1.85,8.71,8.71,0,0,0,3.6.46H68.07V74.35H41c-4,0-2.54-9.12-2.54-13.47V43.64c0-4.22-.6-9.18,2.24-11.51s8.87-1.82,14-1.82h9.8a3.53,3.53,0,0,1,3.53,3.53V43H58.23c-2.64,0-3.95.73-3.95,2.18a1.82,1.82,0,0,0,1,1.85,8.69,8.69,0,0,0,3.3.46Z",
    transform: "translate(-0.96 -0.47)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD6\\u65B9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M32.77,36.93h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.63,36.87H29.38l0,0H32.6Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.6,36.85h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.58,36.84H29.33a1.85,1.85,0,0,0-.33-.12l-.14,0h3.26l.14,0A1.75,1.75,0,0,1,32.58,36.84Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.12,36.67h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.1,36.67h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "31.12 36.19 27.86 36.19 23.72 33.72 26.97 33.72 31.12 36.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.07,36.66H28.82l-.12,0a3.25,3.25,0,0,0-.45-.08h3.26a3.54,3.54,0,0,1,.45.08Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.48,36.55h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.38,36.54h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.37,36.54h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.35,36.54h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.19,36.53h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "24.99 69.73 21.73 69.73 21.77 42.17 25.03 42.17 24.99 69.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M28,74.38H24.77a4.8,4.8,0,0,1-2.08-3.9V70.2h3.25s0,.1,0,.28A4.79,4.79,0,0,0,28,74.38Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "24.99 69.73 21.73 69.73 17.56 67.25 20.82 67.25 24.99 69.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M27,73.53a4,4,0,0,0,1,.87l-4.17-2.48a4.77,4.77,0,0,1-2.12-4.2l4.17,2.48A5.21,5.21,0,0,0,27,73.53Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M31.12,36.53h.36a3.26,3.26,0,0,1,.59.11l.19.06a3,3,0,0,1,.32.12l.16.08a4.7,4.7,0,0,1,2.32,4.33L35,68.8c0,3-2,5.68-4.54,6.06a3.9,3.9,0,0,1-.58,0A3.54,3.54,0,0,1,28,74.38,4.79,4.79,0,0,1,26,70.48c0-.18,0-.23,0-.28l0-27.56c0-3,2.06-5.68,4.55-6.06A4,4,0,0,1,31.12,36.53Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.58,36.84a1.75,1.75,0,0,0-.32-.12l-.14,0h0l-4.14-2.47.17.05a3,3,0,0,1,.41.17l0,0,.06,0,.05,0,0,0,4,2.41-.11-.05,0,0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M29.4,36.87l.05,0,.08,0Zm2.67-.21h0l.14,0a1.75,1.75,0,0,1,.32.12h0l0,0h0l.11.05h0l-4-2.41h-.23Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.53,36.87h-.15l.07,0Zm3.11,0h0Zm.1.05Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.51,36.55h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "29.57 36.11 26.32 36.11 22.16 33.63 25.41 33.63 29.57 36.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M30.53,36.58H27.28a3.92,3.92,0,0,1,.59,0h3.25A4,4,0,0,0,30.53,36.58Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M32.74,36.92l-4-2.41.08,0,4,2.38Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "27.1 73.94 23.85 73.94 19.68 71.45 22.93 71.45 27.1 73.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M29.89,74.91H26.63a3.51,3.51,0,0,1-1.86-.53H28A3.54,3.54,0,0,0,29.89,74.91Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31,36.53a4.23,4.23,0,0,0-.5,0l-4.16-2.49a3.64,3.64,0,0,1,.57,0,3.54,3.54,0,0,1,.73.07l.08,0h.05l.07,0,.06,0,4.14,2.47-.11,0a3.54,3.54,0,0,0-.45-.08H31Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M26.37,34.09H23.12a3.64,3.64,0,0,1,.57,0h3.25A3.64,3.64,0,0,0,26.37,34.09Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M26.2,34.12H22.94l.18,0h3.25Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M26,42.64H22.73c0-3,2.06-5.68,4.55-6.06h3.25C28,37,26,39.69,26,42.64Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.06,34.53H21.8l.16-.08a4.53,4.53,0,0,1,1-.33H26.2a4.35,4.35,0,0,0-1,.33A.8.8,0,0,0,25.06,34.53Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M26.2,34.12l.17,0,4.16,2.49-.17,0-.32.07,0,0-.08,0-.13,0,0,0-.07,0-.13,0-.05,0-.06,0-.1.05-.11.06-4.17-2.48a.8.8,0,0,1,.16-.08A4.35,4.35,0,0,1,26.2,34.12Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "28.27 36.54 25.02 36.54 20.85 34.06 24.1 34.06 28.27 36.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.87,34.63H21.63l.17-.09h3.26l-.17.09Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.63,34.78H21.37l0,0,.07,0,.16-.09h3.25l-.15.09-.07,0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.6,34.8H21.34l0,0h3.26Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.57,34.81h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.32,35H21.07l.25-.18h3.25Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.06,34.53,29.22,37l0,0a4.11,4.11,0,0,0-.39.24l0,0-.12.09h0l-.11.08L24.32,35l.25-.18h0l0,0,0,0,.07,0,.15-.09h0Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "27.54 37 24.28 37 20.11 34.52 23.37 34.52 27.54 37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M23.77,35.47H20.52a5.11,5.11,0,0,1,.55-.48h3.25C24.13,35.14,24,35.3,23.77,35.47Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "26.98 37.49 23.72 37.49 19.56 35 22.82 35 26.98 37.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M24.32,35l4.16,2.49-.14.11a4.17,4.17,0,0,0-.38.34l0,0-4.16-2.48C24,35.3,24.13,35.14,24.32,35Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.77,35.47,27.93,38l-.22.24-.05.05,0,0-.18.21L23.3,36C23.45,35.8,23.61,35.63,23.77,35.47Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "26.51 38 23.25 38 19.09 35.52 22.35 35.52 26.51 38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.3,36H20.05a5.68,5.68,0,0,1,.47-.51h3.25C23.61,35.63,23.45,35.8,23.3,36Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.89,36.56c.13-.2.27-.39.41-.58l4.16,2.49a5.66,5.66,0,0,0-.34.47l-.06.1Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.89,36.56H19.64a5.56,5.56,0,0,1,.41-.58H23.3C23.16,36.17,23,36.36,22.89,36.56Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "26.1 38.57 22.85 38.57 18.68 36.09 21.94 36.09 26.1 38.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M22.51,37.22a7.08,7.08,0,0,1,.38-.66L27.05,39l-.17.28v0s0,.07-.05.1l0,.07a.47.47,0,0,0-.05.1v0l0,.06Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M22.51,37.22H19.26a7.08,7.08,0,0,1,.38-.66h3.25A7.08,7.08,0,0,0,22.51,37.22Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "25.73 39.22 22.48 39.22 18.3 36.76 21.56 36.76 25.73 39.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.18,38H18.93a6.13,6.13,0,0,1,.33-.8h3.25C22.39,37.48,22.28,37.75,22.18,38Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.18,38c.1-.27.21-.54.33-.8l4.17,2.48c-.1.2-.19.41-.27.62s-.05.15-.08.22l-4.16-2.48Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "25.38 40.08 22.12 40.08 17.96 37.59 21.21 37.59 25.38 40.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.17,38.06H18.92v0h3.25Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M22,38.54H18.78c0-.16.09-.32.14-.47h3.25c-.05.15-.1.31-.14.47Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.87,39.37H18.62v0s0-.07,0-.1v0s0-.07,0-.1v0s0-.07,0-.1v0l0-.07v-.12a.24.24,0,0,0,0-.08v0a.43.43,0,0,0,0-.11H22l0,.11v0a.24.24,0,0,0,0,.08l0,.06V39a.44.44,0,0,1,0,.1v0s0,.06,0,.1v0s0,.07,0,.1Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "25.03 42.17 21.77 42.17 17.61 39.69 20.87 39.69 25.03 42.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.82,40.16H18.57V40a.28.28,0,0,1,0-.09v-.14a.53.53,0,0,0,0-.13l0-.25h3.25a2.11,2.11,0,0,0,0,.25.62.62,0,0,0,0,.13V40A.66.66,0,0,0,21.82,40.16Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "20.82 67.25 17.56 67.25 17.61 39.69 20.87 39.69 20.82 67.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "20.87 39.69 25.03 42.17 24.99 69.73 20.82 67.25 20.87 39.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M26,42.1a4.89,4.89,0,0,0,0,.54l-4.16-2.48a.66.66,0,0,1,0-.14v-.27a.62.62,0,0,1,0-.13,2.11,2.11,0,0,1,0-.25v0s0-.07,0-.1v0s0-.07,0-.1v0a.44.44,0,0,0,0-.1v-.17l0-.06a.24.24,0,0,1,0-.08v0l0-.11h0c0-.16.09-.32.14-.47l4.16,2.48c0,.13-.08.25-.11.38s0,.13,0,.19a1.42,1.42,0,0,0,0,.2,1.16,1.16,0,0,0,0,.18v0a1.13,1.13,0,0,0,0,.18q0,.11,0,.18v0A1.1,1.1,0,0,0,26,42.1Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M23.89,71.92H20.63a4.78,4.78,0,0,1-2.11-4.2h3.25A4.77,4.77,0,0,0,23.89,71.92Z",
    transform: "translate(-0.96 -0.47)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "T_\\u7B2C\\u4E8C",
    "data-name": "T \\u7B2C\\u4E8C"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84,3,79.4.51A4.11,4.11,0,0,1,81.05.6l4.56,2.48A4.12,4.12,0,0,0,84,3",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.61,3.08,81.05.6a3.92,3.92,0,0,1,.77.28l4.56,2.48a4.17,4.17,0,0,0-.77-.28",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.38,3.36,81.82.88,82,1l4.56,2.48-.14-.08",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.51,3.08,79,.6A3.58,3.58,0,0,1,79.4.51L84,3a3.58,3.58,0,0,0-.45.09",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8.14,35.39,3.58,32.91a4.42,4.42,0,0,1-2.21-3.57l4.56,2.48a4.42,4.42,0,0,0,2.21,3.57",
    transform: "translate(-0.96 -0.47)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "8.9 20.57 4.34 18.09 78 0.13 82.55 2.61 8.9 20.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "4.97 31.35 0.41 28.87 0.02 24.34 4.58 26.82 4.97 31.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M84,3a4.19,4.19,0,0,1,4.77,4l.4,4.54a6,6,0,0,1-4.32,6.25l-73.66,18-.45.08a4.19,4.19,0,0,1-4.77-4l-.39-4.53A6,6,0,0,1,9.86,21l73.65-18A3.58,3.58,0,0,1,84,3Z",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M5.54,27.29,1,24.81a5.82,5.82,0,0,1,.34-2.52l4.56,2.48a5.82,5.82,0,0,0-.34,2.52",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M5.88,24.77,1.32,22.29a7.43,7.43,0,0,1,.37-.81L6.25,24a7.43,7.43,0,0,0-.37.81",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M6.25,24,1.69,21.48a5.27,5.27,0,0,1,.4-.64l4.55,2.48a6.82,6.82,0,0,0-.39.64",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M6.64,23.32,2.09,20.84a3.87,3.87,0,0,1,.43-.55l4.56,2.48a4.82,4.82,0,0,0-.44.55",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M7.08,22.77,2.52,20.29a5.78,5.78,0,0,1,.49-.5l4.56,2.48a5.78,5.78,0,0,0-.49.5",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7.57,22.27,3,19.79a5.09,5.09,0,0,1,.58-.46l4.56,2.48a5.09,5.09,0,0,0-.58.46",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.15,21.81,3.59,19.33a4.51,4.51,0,0,1,.77-.44l4.56,2.48a4.51,4.51,0,0,0-.77.44",
    transform: "translate(-0.96 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.92,21.37,4.36,18.89a4.37,4.37,0,0,1,.94-.33L9.86,21a4.37,4.37,0,0,0-.94.33",
    transform: "translate(-0.96 -0.47)"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.76,44.49V56.64l-5.33.09V74.12h-15V31.6a3.5,3.5,0,0,1,3.5-3.5h7.76a3.73,3.73,0,0,1,3.74,3.73V44.59Zm15.48-12.94V73.94H141.38V31.67a3.75,3.75,0,0,1,3.75-3.75h5.48A3.64,3.64,0,0,1,154.24,31.55Z",
    transform: "translate(-0.96 -0.47)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "N\\u5176\\u4ED6\\u5B57\\u4F53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.14,29.23h8a2.06,2.06,0,0,1,1.77,1L184.47,54V31a1.71,1.71,0,0,1,1.68-1.74h7.76a1.56,1.56,0,0,1,1.53,1.58V74h-11L170.38,49.4V74l-10.45-.1L160,31.13S160.2,29.23,161.14,29.23Z",
    transform: "translate(-0.96 -0.47)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.45,30l-11.8,18.55V74.12H250V48.59L237.93,29.74a1.06,1.06,0,0,1,.89-1.64h10.79a2,2,0,0,1,1.73,1l5.34,8.56,5.77-8.57a2.17,2.17,0,0,1,1.8-.95h10.13A1.26,1.26,0,0,1,275.45,30Z",
    transform: "translate(-0.96 -0.47)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.52,32.09v42H200.86V31a2.86,2.86,0,0,1,2.85-2.86h6.82A4,4,0,0,1,214.52,32.09Z",
    transform: "translate(-0.96 -0.47)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a33ac3219bc753be5a66b50caf37081.svg";
export { ForwardRef as ReactComponent };